function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useMemo, useState } from 'react';
import c from 'classnames';
import Immutable, { List } from 'immutable';
import { useTranslation } from 'react-i18next';
var WebformActions = function WebformActions(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var entity = props.entity,
    pages = props.pages,
    onPreviousPage = props.onPreviousPage,
    currentPage = props.currentPage,
    handleSubmit = props.handleSubmit,
    isSubmitting = props.isSubmitting,
    webformHasWizardWithButtons = props.webformHasWizardWithButtons;
  var classNames = entity.getIn(['#attributes', 'class'], List());
  var wrapperClassNames = c('WebformComponent__submit', classNames.toJS());
  var elementClassNames = c('Button', entity.getIn(['#submit__attributes', 'class'], Immutable.List()).toJS().join(' '), {
    loading: isSubmitting
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    autoSubmit = _useState2[0],
    enableAutosubmit = _useState2[1];
  if (webformHasWizardWithButtons) {
    return null;
  }
  var collectInitialValuesFlat = function collectInitialValuesFlat(entity) {
    var output = new Immutable.List();
    var mappedEntity = Immutable.fromJS(entity);
    output = output.push(mappedEntity.get('#webform_key'));

    // Collect child items.
    var children = Immutable.fromJS(entity);
    children.keySeq().forEach(function (k) {
      if (k.indexOf('#') === 0) {
        children = children.delete(k);
      }
    });
    children.entrySeq().forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        e = _ref2[1];
      var c = collectInitialValuesFlat(e);
      output = output.merge(c);
    });
    return output;
  };
  var onNextButton = function onNextButton() {
    var setFieldTouched = props.setFieldTouched,
      validateForm = props.validateForm,
      entities = props.entities,
      onNextPage = props.onNextPage,
      handleSubmit = props.handleSubmit;

    // Determine all children in this page.
    var fieldsInThisPage = collectInitialValuesFlat(entities);
    validateForm().then(function (validation) {
      var validated = true;
      Immutable.fromJS(validation).keySeq().forEach(function (invalidField) {
        // Check if this field is contained by this page.
        if (fieldsInThisPage.contains(invalidField)) {
          validated = false;
          setFieldTouched(invalidField);
        }
      });
      if (validated) {
        if (currentPage !== pages.last()) {
          onNextPage();
        } else {
          handleSubmit();
        }
      }
    });
  };
  // Check if we should use the page labels or the submit actions  per page labels.
  var hidePreviousLabel = entity.get('#wizard_prev_hide', false);
  var previousLabel = entity.get('#wizard_prev__label', t('webform.actions.wizard_prev_label'));
  var hideNextLabel = entity.get('#wizard_next_hide', false);
  var nextLabel = useMemo(function () {
    // Check if we should use the page labels or the submit actions per page.
    if (currentPage === pages.last()) {
      return entity.get('#submit__label', t('webform.actions.submit_label'));
    }
    return entity.get('#wizard_next__label', t('webform.actions.wizard_next_label'));
  }, [currentPage, pages, entity, t]);
  var onClickPrevious = function onClickPrevious() {};
  var onClickNext = handleSubmit;
  if (pages.size !== 0) {
    onClickPrevious = onPreviousPage;
    onClickNext = onNextButton;
  }

  // If we hide the submit button when using Wizard pages, auto-submit on the last page.
  useEffect(function () {
    if (entity.get('#submit_hide', false) && currentPage === pages.last() && !isSubmitting) {
      enableAutosubmit(true);
    }
  }, [entity, currentPage, pages, isSubmitting]);

  // Use a second effect to prevent multiple submissions, since Formik re-renders often.
  useEffect(function () {
    if (autoSubmit) {
      handleSubmit(false);
    }
  }, [autoSubmit]);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassNames
  }, !hidePreviousLabel && currentPage !== pages.first() && /*#__PURE__*/React.createElement("button", {
    className: c(elementClassNames, 'WebformComponent__submit__prev'),
    type: "button",
    onClick: onClickPrevious,
    disabled: isSubmitting
  }, previousLabel), (!hideNextLabel || currentPage === pages.last()) && /*#__PURE__*/React.createElement("button", {
    className: c(elementClassNames, 'WebformComponent__submit__next'),
    type: "button",
    onClick: onClickNext,
    disabled: isSubmitting
  }, nextLabel));
};
export default WebformActions;